export enum Extensions {
  QuestionnaireResponseTaskId = "http://quiltedhealth.com/sd/questionnaire-response-task-id",
  QuestionnaireItemControl = "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
  InterpreterRequired = "http://hl7.org/fhir/StructureDefinition/patient-interpreterRequired",
  IndividualPronouns = "http://hl7.org/fhir/StructureDefinition/individual-pronouns",
  NoReportedProblems = "http://quiltedhealth.com/sd/no-reported-problems",
  NoReportedAllergies = "http://quiltedhealth.com/sd/no-reported-allergies",
  NoReportedMedications = "http://quiltedhealth.com/sd/no-reported-medications",
  DisplayAllergyOnClientSidePanel = "http://quiltedhealth.com/sd/display-allergy-client-sidepanel",
  DisplayMedicationOnClientSidePanel = "http://quiltedhealth.com/sd/display-medication-client-sidepanel",
  MedicationStartDate = "http://quiltedhealth.com/sd/medication-start-date",
  MedicationNote = "http://quiltedhealth.com/sd/medication-note",
  UploadedResultTitle = "http://quiltedhealth.com/sd/uploaded-result-title",
  MedicationPrescriber = "http://quiltedhealth.com/sd/medication-prescriber",
  PatientSMSAgreement = "http://quiltedhealth.com/sd/patient-sms-agreement",
  QuestionnaireFieldPlaceholder = "http://quiltedhealth.com/sd/questionnaire-field-placeholder",
  QuestionnaireGroupNameTitle = "http://quiltedhealth.com/sd/questionnaire-field-group-name-title",
  QuestionnaireFieldIcon = "http://quiltedhealth.com/sd/questionnaire-field-icon",
  QuestionnaireFieldMask = "http://quiltedhealth.com/sd/questionnaire-field-mask",
  QuestionnaireFieldDate = "http://quiltedhealth.com/sd/questionnaire-field-date",
  QuestionnaireFieldRightSection = "http://quiltedhealth.com/sd/questionnaire-field-right-section",
  QuestionnaireRelatedFields = "http://quiltedhealth.com/sd/questionnaire-related-fields",
  QuestionnaireItemHasNote = "http://quiltedhealth.com/sd/questionnaire-item-has-note",
  QuestionnaireItemMinRange = "http://quiltedhealth.com/sd/questionnaire-field-min-range",
  QuestionnaireItemMaxRange = "http://quiltedhealth.com/sd/questionnaire-field-max-range",
  QuestionnaireItemAllowDecimal = "http://quiltedhealth.com/sd/questionnaire-item-allow-decimal",
  QuestionnaireItemAllowNegative = "http://quiltedhealth.com/sd/questionnaire-item-allow-negative",
  QuestionnaireItemShowPlusPrefix = "http://quiltedhealth.com/sd/questionnaire-item-show-plus-prefix",
  QuestionnaireItemMaxDecimalPlaces = "http://hl7.org/fhir/StructureDefinition/maxDecimalPlaces",
  QuestionnaireItemMaxValue = "http://hl7.org/fhir/StructureDefinition/maxValue",
  QuestionnaireItemMinValue = "http://hl7.org/fhir/StructureDefinition/minValue",
  QuestionnaireItemReferenceResourceType = "http://quiltedhealth.com/sd/questionnaire-item-reference-resource-type",
  QuestionnaireItemReferenceCreatable = "http://quiltedhealth.com/sd/questionnaire-item-reference-creatable",
  QuestionnaireItemReferenceSearchCriteria = "http://quiltedhealth.com/sd/questionnaire-item-reference-search-criteria",
  QuestionnaireFieldAutoPopulate = "http://quiltedhealth.com/sd/questionnaire-field-autopopulate",
  QuestionnaireFieldTimestampEditable = "http://quiltedhealth.com/sd/questionnaire-field-timestamp-editable",
  CareTeamParticipantPrimary = "http://quiltedhealth.com/sd/care-team-participant-primary",
  CareTeamParticipantAutoSubscribeToMessages = "http://quiltedhealth.com/sd/care-team-participant-auto-subscribe-to-messages",
  CareTeamParticipantAllowClientToMessage = "http://quiltedhealth.com/sd/care-team-participant-allow-client-to-message",
  CareTeamParticipantStatus = "http://quiltedhealth.com/sd/care-team-participant-status",
  GenderIdentity = "http://hl7.org/fhir/us/core/StructureDefinition/us-core-genderIdentity",
  SexualOrientation = "http://hl7.org/fhir/us/cdmh/StructureDefinition/cdmh-patient-sexualOrientation",
  SexAssignedAtBirth = "http://hl7.org/fhir/us/core/StructureDefinition/us-core-birthsex",
  CanCallToPreferredContact = "http://quiltedhealth.com/sd/can-call-to-preferred-contact",
  CanLeaveVoicemailToPreferredContact = "http://quiltedhealth.com/sd/can-leave-voicemail-to-preferred-contact",
  QuestionnaireExpiration = "http://quiltedhealth.com/sd/questionnaire-expiration",
  BirthPlace = "http://hl7.org/fhir/StructureDefinition/patient-birthPlace",
  GeneticParentIsCoParent = "http://quiltedhealth.com/sd/genetic-parent-is-co-parent",
  GeneticParentWillBeOnBirthCertificate = "http://quiltedhealth.com/sd/genetic-parent-will-be-on-birth-certificate",
  QuestionnaireResponseSignature = "http://hl7.org/fhir/StructureDefinition/questionnaireresponse-signature",
  QuestionnaireRelatedConsent = "http://quiltedhealth.com/sd/questionnaire-related-consent",
  QuestionnaireSignatureRequired = "http://hl7.org/fhir/StructureDefinition/questionnaire-signatureRequired",
  QuestionnaireResponseItemIsAccepted = "http://quiltedhealth.com/sd/questionnaire-response-item-is-accepted",
  QuestionnaireResponseNamedVersion = "http://quiltedhealth.com/sd/questionnaire-response-named-version",
  ObservationPreviousVersion = "http://quiltedhealth.com/sd/observation-previous-version",
  QuestionnaireItemHidden = "http://hl7.org/fhir/StructureDefinition/questionnaire-hidden",
  QuestionnaireItemScore = "http://quiltedhealth.com/sd/questionnaire-item-score",
  QuestionnaireResponseIsCompleted = "http://quiltedhealth.com/sd/questionnaire-response-is-completed",
  QuestionnaireItemFormset = "http://quiltedhealth.com/sd/questionnaire-item-formset",
  QuestionnaireItemFormsetShowTitle = "http://quiltedhealth.com/sd/questionnaire-item-formset-show-title",
  QuestionnaireItemControlledFormset = "http://quiltedhealth.com/sd/questionnaire-item-controlled-formset",
  QuestionnaireItemFormsetController = "http://quiltedhealth.com/sd/questionnaire-item-formset-controller",
  QuestionnaireItemAlert = "http://quiltedhealth.com/sd/questionnaire-item-alert",
  FamilyMemberHistoryConditionStatus = "http://quiltedhealth.com/sd/family-member-history-condition-status",
  AssessmentRelatedAppointmentType = "http://quiltedhealth.com/sd/assessment-related-appointment-type",
  AssessmentCalendarId = "http://quiltedhealth.com/sd/assessment-calendar-id",
  AssessmentAppointmentTypeId = "http://quiltedhealth.com/sd/assessment-appointment-type-id",
  Timezone = "http://hl7.org/fhir/StructureDefinition/timezone",
  PracticeDefaultLocation = "http://quiltedhealth.com/sd/practice-default-location",
  AcuityUserId = "http://quiltedhealth.com/sd/acuity-user-id",
  ArtifactTitle = "http://hl7.org/fhir/StructureDefinition/artifact-title",
  SchedulingDateOverrides = "http://quiltedhealth.com/sd/scheduling-date-overrides",
  SexSpecify = "http://quiltedhealth.com/sd/sex-specify",
  ArtifactRelatedArtifact = "http://hl7.org/fhir/StructureDefinition/artifact-relatedArtifact",
  EncounterPhysicalExam = "http://quiltedhealth.com/sd/encounter-physical-exam",
  PhysicalExamSectionCode = "http://quiltedhealth.com/sd/physical-exam-section-code",
  QuestionnaireItemOrder = "http://quiltedhealth.com/sd/questionnaire-item-order",
  EditedBy = "http://quiltedhealth.com/sd/edited-by",
  Race = "http://quiltedhealth.com/sd/race",
  PartnerNotes = "http://quiltedhealth.com/sd/support-network-partner-status-comments",
  CanShareConfidentialInformation = "http://quiltedhealth.com/sd/can-share-confidential-information",
  IsGeneticParent = "http://quiltedhealth.com/sd/is-genetic-parent",
  UploadedDocument = "http://quiltedhealth.com/sd/uploaded-document",
  AcuityAppointmentTypeClassSize = "http://quiltedhealth.com/sd/qh-acuity-appointment-type-class-size",
  AcuityAppointmentTypePaddingBefore = "http://quiltedhealth.com/sd/qh-acuity-appointment-type-padding-before",
  AcuityAppointmentTypePaddingAfter = "http://quiltedhealth.com/sd/qh-acuity-appointment-type-padding-after",
  AcuityAppointmentTypeColor = "http://quiltedhealth.com/sd/qh-acuity-appointment-type-color",
  AcuityAppointmentTypeDuration = "http://quiltedhealth.com/sd/qh-acuity-appointment-type-duration",
  AcuityAppointmentTypeKind = "http://quiltedhealth.com/sd/qh-acuity-appointment-type-kind",
  QhScheduleName = "http://quiltedhealth.com/sd/qh-schedule-name",
  QhScheduleModelAppointmentTypeAvailability = "http://quiltedhealth.com/sd/qh-schedule-model-appointment-type-availability",
  QuestionnaireResponseMembers = "http://quiltedhealth.com/fhir/StructureDefinition/questionnaire-response-members",
  QuestionnaireItemInlineEnableWhen = "http://quiltedhealth.com/sd/questionnaire-item-inline-enable-when",
  HasCodingInputDetails = "http://quiltedhealth.com/sd/has-coding-input-details",
  ParentQuestionnaireResponseVersionId = "http://quiltedhealth.com/sd/parent-questionnaire-response-version-id",
  QuestionnaireItemFormsetShouldBlockFirstItemDelete = "http://quiltedhealth.com/sd/questionnaire-item-formset-should-block-first-item-delete",
  PhysicalExamQuestionType = "http://quiltedhealth.com/sd/physical-exam-question-type",
  FhirPathCriteriaExpression = "https://medplum.com/fhir/StructureDefinition/fhir-path-criteria-expression",
  QuestionnaireFieldDateCanSelectFutureDates = "http://quiltedhealth.com/sd/questionnaire-field-date-can-select-future-dates",
  QuestionFlag = "http://quiltedhealth.com/sd/question-flag",
  QuestionnaireInformationText = "http://quiltedhealth.com/sd/questionnaire-information-text",
  QuestionnaireShouldShowTitle = "http://quiltedhealth.com/sd/questionnaire-should-show-title",
  SubscriptionSupportedInteraction = "https://medplum.com/fhir/StructureDefinition/subscription-supported-interaction",
  CoverageUnits = "http://quiltedhealth.com/fhir/StructureDefinition/coverage-units",
  CoverageModifiers = "http://quiltedhealth.com/fhir/StructureDefinition/coverage-modifiers",
  CoverageProcedure = "http://quiltedhealth.com/fhir/StructureDefinition/coverage-procedure",
  CoverageEncounter = "http://quiltedhealth.com/fhir/StructureDefinition/coverage-encounter",
  /** Billable unit count for an encounter Procedure (valueInteger). */
  ProcedureUnits = "http://quiltedhealth.com/fhir/StructureDefinition/procedure-units",
  /** CPT modifier applied to a Procedure (valueString). Repeatable — one extension per modifier. */
  ProcedureModifiers = "http://quiltedhealth.com/fhir/StructureDefinition/procedure-modifiers",
  /**
   * CPT or custom procedure modifier on a ChargeItem (valueString).
   * Repeatable — zero or more modifiers, one extension per value.
   */
  ChargeItemProcedureModifiers = "http://quiltedhealth.com/sd/procedure-modifiers",
  /**
   * Whether a biller has edited this ChargeItem's modifiers (valueBoolean).
   *
   * Written on every edit a biller saves from the billing tab. A charge whose modifiers a biller
   * cleared and a charge nobody has edited both carry no
   * {@link Extensions.ChargeItemProcedureModifiers}, so this marker is what separates them. Only
   * the second reads its modifiers off the Procedure it was captured from.
   */
  ChargeItemModifiersEdited = "http://quiltedhealth.com/sd/charge-item-modifiers-edited",
  /**
   * Place of service on a chart-level custom-service ChargeItem (valueString).
   * Values match Services tab Place of Service options (e.g. office, home, hospital).
   */
  ChargeItemPlaceOfService = "http://quiltedhealth.com/sd/charge-item-place-of-service",
  /**
   * Biller-facing note on a ChargeItem (valueString), copied from the Procedure the charge was
   * captured from and rewritten by every biller edit.
   *
   * The charge is the billing record of truth, so the billing tab reads a row's notes from here
   * rather than from the Procedure. Mirrors {@link Extensions.ProcedureBillerNotes} the same way
   * {@link Extensions.ChargeItemProcedureModifiers} mirrors {@link Extensions.ProcedureModifiers}.
   */
  ChargeItemBillerNotes = "http://quiltedhealth.com/sd/charge-item-biller-notes",
  /**
   * Provider-facing note on a ChargeItem (valueString), copied from the Procedure the charge was
   * captured from. Mirrors {@link Extensions.ProcedureProviderNotes}.
   */
  ChargeItemProviderNotes = "http://quiltedhealth.com/sd/charge-item-provider-notes",
  /** Biller-facing note on an encounter Procedure (valueString). */
  ProcedureBillerNotes = "http://quiltedhealth.com/fhir/StructureDefinition/procedure-biller-notes",
  /** Provider-facing note on an encounter Procedure (valueString). */
  ProcedureProviderNotes = "http://quiltedhealth.com/fhir/StructureDefinition/procedure-provider-notes",
  QhBirthSource = "http://quiltedhealth.com/sd/birth/source",
  QhBirthSourceType = "http://quiltedhealth.com/sd/birth/sourceType",
  QhBirthSourceLaborStage = "http://quiltedhealth.com/sd/birth/sourceLaborStage",
  QuestionnaireResponseParentVersionId = "http://quiltedhealth.com/sd/questionnaire-response-parent-version-id",
  /** Encounter QuestionnaireResponse `meta.versionId` for the sign-off or amend event this Provenance records. */
  ProvenanceEncounterQuestionnaireResponseVersionId = "http://quiltedhealth.com/sd/provenance-encounter-questionnaire-response-version-id",
  /** JSON array of labor-stage membership moves recorded during an amend session. */
  LaborAmendStageMembershipChanges = "http://quiltedhealth.com/sd/labor-amend-stage-membership-changes",
  QuestionnaireRequired = "http://quiltedhealth.com/sd/questionnaire-required",
  PractitionerPermissionFlags = "http://quiltedhealth.com/sd/practitioner-permission-flags",
  PractitionerRoleCredentials = "http://quiltedhealth.com/sd/practitionerrole-credentials",
  NotificationPreferences = "http://quiltedhealth.com/sd/notification-preferences",
  ValueSetIsCreatable = "http://quiltedhealth.com/sd/valueset-is-creatable",
  QuestionnaireFieldLabelStyle = "http://quiltedhealth.com/sd/questionnaire-field-label-style",
  PractitionerRoleAvailabilityLocation = "http://quiltedhealth.com/sd/practitionerrole-availability-location",
  LocationHasRegularWeeklySchedule = "http://quiltedhealth.com/sd/location-has-regular-weekly-schedule",
  CloseoutFlag = "http://quiltedhealth.com/sd/closeout-flag",
  /** Pregnancy `List` closed by this pregnancy-closeout QuestionnaireResponse (`valueReference`). */
  PregnancyCloseoutPregnancyRecord = "http://quiltedhealth.com/sd/pregnancy-closeout-pregnancy-record",
  AssessmentManuallySentQuestionnaireResponseNote = "http://quiltedhealth.com/sd/assessment-manually-sent-questionnaire-response-note",
  AssessmentManuallySent = "http://quiltedhealth.com/sd/assessment-manually-sent",
  IntakeFormsetIndex = "http://quiltedhealth.com/sd/intake-formset-index",
  IntakeFormsetSection = "http://quiltedhealth.com/sd/intake-formset-section",
  IntakeFormsLastSavedSection = "http://quiltedhealth.com/sd/intake-forms-last-saved-section",
  IntakeFormsClientWizardLastSection = "http://quiltedhealth.com/sd/intake-forms-client-wizard-last-section",
  ChecklistTaskOrder = "http://quiltedhealth.com/sd/checklist-task-order",
  FolderInitialSettings = "http://quiltedhealth.com/sd/folder-initial-settings",
  EduResourceLinkageDeliverySource = "http://quiltedhealth.com/sd/edu-resource-linkage-delivery-source",
  AttachmentFilename = "http://quiltedhealth.com/sd/attachment-filename",
  InsuranceVerificationTier = "http://quiltedhealth.com/sd/insurance-verification-tier",
  InsuranceVerificationPayer = "http://quiltedhealth.com/sd/insurance-verification-payer",
  InsurancePlanTier = "http://quiltedhealth.com/sd/insurance-plan-tier",
  CoverageVerificationDetails = "http://quiltedhealth.com/sd/coverage-verification-details",
  AppointmentExcludedFromEligibilityList = "http://quiltedhealth.com/sd/appointment-excluded-from-eligibility-list",
  PatientHasUser = "http://quiltedhealth.com/sd/patient-has-user",
  CalendarSyncConsentAt = "http://quiltedhealth.com/sd/calendar-sync-consent-at",
  CalendarSyncEndpoint = "http://quiltedhealth.com/sd/calendar-sync-endpoint",
  CalendarSyncPractitioner = "http://quiltedhealth.com/sd/calendar-sync-practitioner",
  CalendarSyncPractitionerRole = "http://quiltedhealth.com/sd/calendar-sync-practitioner-role",
  /** Marks a folder Linkage alternate item as deactivated for that patient (valueBoolean). */
  FolderDisabled = "http://quiltedhealth.com/sd/folder-disabled",
  /** Marks a DocumentReference Linkage alternate item as deactivated for that patient. */
  ResourceDisabled = "http://quiltedhealth.com/sd/resource-disabled",
  ClassEventEnrollmentVerificationCodeHash = "http://quiltedhealth.com/sd/class-event-enrollment-verification-code-hash",
  ClassEventEnrollmentVerificationExpiresAt = "http://quiltedhealth.com/sd/class-event-enrollment-verification-expires-at",
  ClassEventEnrollmentVerificationUsed = "http://quiltedhealth.com/sd/class-event-enrollment-verification-used",
  ClassEventEnrollmentVerificationAppointmentId = "http://quiltedhealth.com/sd/class-event-enrollment-verification-appointment-id",
  ClassEventEnrollmentVerificationOrganizationId = "http://quiltedhealth.com/sd/class-event-enrollment-verification-organization-id",
  ClassEventEnrollmentVerificationScheduleId = "http://quiltedhealth.com/sd/class-event-enrollment-verification-schedule-id",
  ClassEventEnrollmentVerificationAppointmentTypeId = "http://quiltedhealth.com/sd/class-event-enrollment-verification-appointment-type-id",
  /** Relationship of an encounter participant (e.g. others present) to the client. */
  EncounterParticipantRelationshipToClient = "http://quiltedhealth.com/sd/encounter-participant-relationship-to-client",
  ServicePayer = "http://quiltedhealth.com/sd/service-payer",
  /** How a ledger payment moved (Credit Card, Check, …) on PaymentReconciliation. */
  LedgerPaymentMethod = "http://quiltedhealth.com/sd/ledger-payment-method",
  /** Ledger Source on a PaymentReconciliation (Insurance, Self-Pay, Practice, or Other). */
  LedgerSource = "http://quiltedhealth.com/sd/ledger-source",
  /** Per-statement balance still owed (Invoice); recomputed with each PaymentReconciliation. */
  BalanceDue = "http://quiltedhealth.com/sd/balance-due",
  /**
   * A cancelled sub-statement's balance returned to its parent (Invoice, complex: `amount` Money,
   * `toStatement` string, `returnedAt` dateTime).
   */
  BalanceReturned = "http://quiltedhealth.com/sd/balance-returned",
  /** The balance a sub-statement was billed forward with (Invoice, valueMoney), stamped by the bot. */
  BilledForwardAmount = "http://quiltedhealth.com/sd/billed-forward-amount",
  /** The sub-statement a statement's balance was billed forward to (Invoice, valueReference), stamped by the bot. */
  BilledForwardTo = "http://quiltedhealth.com/sd/billed-forward-to",
  /** The posting a carried PaymentReconciliation was copied from (valueReference). */
  LedgerCarriedFrom = "http://quiltedhealth.com/sd/ledger-carried-from",
  /** Balance remaining after one posting (PaymentReconciliation, valueMoney), for Payment History. */
  LedgerBalanceAfter = "http://quiltedhealth.com/sd/ledger-balance-after",
  /** Practitioner who recorded a ledger payment (PaymentReconciliation, valueReference). */
  PaymentRecordedBy = "http://quiltedhealth.com/sd/payment-recorded-by",
  /**
   * `Coverage.order` of the coverage a statement is billed under (Invoice, valueInteger).
   *
   * `Invoice.recipient` names the payer Organization, which does not identify a coverage on its
   * own: a client can hold a Primary and a Secondary plan through the same insurer. The tier
   * recorded here is what tells those two apart. A statement written before this was recorded
   * carries no such extension and resolves its coverage by payer alone.
   */
  BilledCoverageOrder = "http://quiltedhealth.com/sd/billed-coverage-order",
  /** Date a statement was closed, whether paid or denied (Invoice, valueDateTime). */
  StatementClosureDate = "http://quiltedhealth.com/sd/statement-closure-date",
  /**
   * The Invoice version a statement Provenance describes, carried on the target reference
   * (Provenance.target.extension, valueString). Read the version back with `medplum.readVersion`.
   */
  ProvenanceInvoiceVersionId = "http://quiltedhealth.com/sd/provenance-invoice-version-id",
  /**
   * The ChargeItem version a service Provenance describes, carried on the target reference
   * (Provenance.target.extension, valueString). Read the version back with `medplum.readVersion`.
   */
  ProvenanceChargeItemVersionId = "http://quiltedhealth.com/sd/provenance-charge-item-version-id",
  /**
   * The DocumentReference version a statement attachment Provenance describes, carried on the target
   * reference (Provenance.target.extension, valueString). Read the version back with `medplum.readVersion`.
   */
  ProvenanceDocumentReferenceVersionId = "http://quiltedhealth.com/sd/provenance-document-reference-version-id",
  /**
   * Groups one statement's own Authorizations & Signatures answers (Invoice). They stand in for
   * the issuing practice's defaults. It holds one answer extension per question, and each of those
   * has its own URL and StructureDefinition. All answers are written together, so an edited
   * statement keeps its own answers even after the practice changes its settings.
   */
  StatementAuthorizations = "http://quiltedhealth.com/sd/statement-authorizations",
  /** Provider accepts assignment of benefits, for one statement. `Yes` or `No`. */
  StatementProviderAcceptAssignment = "http://quiltedhealth.com/sd/statement-provider-accept-assignment",
  /** Payment authorized directly to the provider, for one statement. `Yes` or `No`. */
  StatementDirectPaymentAuthorized = "http://quiltedhealth.com/sd/statement-direct-payment-authorized",
  /** Provider signature on file, for one statement. `Yes` or `No`. */
  StatementProviderSignatureOnFile = "http://quiltedhealth.com/sd/statement-provider-signature-on-file",
  /** Client signature on file, for one statement. `Yes` or `No`. */
  StatementPatientSignatureOnFile = "http://quiltedhealth.com/sd/statement-patient-signature-on-file",
  /** Facility admission details billed on a statement (Invoice, nested extension). */
  FacilityAdmission = "http://quiltedhealth.com/sd/facility-admission",
  HasFacilityFee = "http://quiltedhealth.com/sd/has-facility-fee",
  /**
   * Canonical newborn `Patient` reference on the Encounter-creation `QuestionnaireResponse` for a
   * Newborn IPP or Newborn Postpartum encounter (valueReference). `Encounter.subject` and the
   * creation QR's own `subject` stay the mother; this extension is the only place a standalone
   * newborn-selection picker records which newborn the encounter is for.
   */
  NewbornPatientReference = "http://quiltedhealth.com/sd/newborn-patient-reference",
  /**
   * On a client's applied `Flag`: a `Reference(Flag)` to the practice library entry it was applied
   * from. The link is the library entry's logical id, never its derived code — a rename re-derives
   * the code, so only the id survives one. See `buildUpdatedPracticeFlagResource`.
   */
  ClientFlagLibraryEntry = "http://quiltedhealth.com/sd/client-flag-library-entry",
  /**
   * On a client's applied `Flag`: a `Reference(Practitioner)` to whoever removed it from the chart.
   * `Flag.author` is the flag's creator, a different fact, so removal needs its own home. Written
   * by the same update that deactivates the flag, so the archive reads it without a `Provenance`
   * lookup per row.
   */
  ClientFlagRemovedBy = "http://quiltedhealth.com/sd/client-flag-removed-by",
  /**
   * On a client's applied `Flag`: the clinician's reason for removing it — a listed reason's label,
   * or their own words for `Other`. PHI — it is chart prose, so it must never reach a log, a
   * Sentry payload, or an error message.
   */
  ClientFlagRemovalReason = "http://quiltedhealth.com/sd/client-flag-removal-reason",
  /**
   * On a removed client `Flag`: `valueBoolean: true` when its library entry had already been deleted
   * at the moment of removal, so the chart was showing it as `Deprecated`. Written only when true.
   * `Flag` has no element for this, and the archive shows each flag as it was when archived, so a
   * library delete after the removal must not change it.
   */
  ClientFlagLibraryEntryDeleted = "http://quiltedhealth.com/sd/client-flag-library-entry-deleted",
  /**
   * On a Health Gorilla lab order `ServiceRequest`: the ordering physician's account number with
   * the performing lab. Health Gorilla keys these lab order extensions by bare name rather than a
   * URL, matching the SDK's own `performingLabAccountNumber`.
   */
  PerformingLabPhysicianAccountNumber = "performingLabPhysicianAccountNumber",
  /**
   * On an `Encounter`: face-to-face time the provider spent with the client, as a `valueDuration`
   * in UCUM minutes. Added to `EncounterCareCoordinationTime`, it makes up `Encounter.length`.
   */
  EncounterFaceToFaceTime = "http://quiltedhealth.com/sd/encounter-face-to-face-time",
  /**
   * On an `Encounter`: time the provider spent coordinating the client's care, as a
   * `valueDuration` in UCUM minutes. Added to `EncounterFaceToFaceTime`, it makes up
   * `Encounter.length`.
   */
  EncounterCareCoordinationTime = "http://quiltedhealth.com/sd/encounter-care-coordination-time",
  /** A practice's logo (Organization, valueAttachment). FHIR R4 Organization has no photo element. */
  PracticeLogo = "http://quiltedhealth.com/sd/practice-logo",
  /** Consent to show the practice logo to clients (Organization, valueBoolean). */
  PracticeLogoConsent = "http://quiltedhealth.com/sd/practice-logo-consent",
  /** Whether every Practitioner User invited into the practice must enroll in MFA (Organization, valueBoolean). */
  OrganizationMfaRequired = "http://quiltedhealth.com/sd/organization-mfa-required",
  /** Links a Practitioner to a Health Gorilla location (Practitioner, valueReference to the practice Organization). */
  HealthGorillaPractitionerLocation = "https://medplum.com/integrations/health-gorilla/practitioner-location",
}
